import { OwaDate, startOfDay, userDate, subDays, isBefore } from 'owa-datetime';
import SnoozeSubMenuDate from '../../store/viewSchema/SnoozeSubMenuDate';
import loc from 'owa-localize';
import {
    DayOfBillDueText,
    OneDayBeforeBillDueText,
    TwoDaysBeforeBillDueText,
} from '../../strings.locstring.json';
import { observableNow } from 'owa-observable-datetime';

function dayOfDate(date: OwaDate): OwaDate {
    return startOfDay(date);
}
function dayBeforeDate(date: OwaDate): OwaDate {
    return subDays(date, 1);
}
function twoDaysBeforeDate(date: OwaDate): OwaDate {
    return subDays(date, 2);
}

export default function getTxpSnoozeDateOptions(dateDue: string): SnoozeSubMenuDate[] {
    const dueOwaDate: OwaDate = userDate(dateDue);
    const dayOfOwaDate: OwaDate = dayOfDate(dueOwaDate);
    const dayBeforeOwaDate: OwaDate = dayBeforeDate(dayOfOwaDate);
    const twoDaysBeforeOwaDate: OwaDate = twoDaysBeforeDate(dayOfOwaDate);
    const dates: SnoozeSubMenuDate[] = [];
    const now: OwaDate = observableNow();

    if (isBefore(now, dayOfOwaDate)) {
        dates.push({
            date: dayOfOwaDate,
            name: loc(DayOfBillDueText),
        });
    }

    if (isBefore(now, dayBeforeOwaDate)) {
        dates.push({
            date: dayBeforeOwaDate,
            name: loc(OneDayBeforeBillDueText),
        });
    }

    if (isBefore(now, twoDaysBeforeOwaDate)) {
        dates.push({
            date: twoDaysBeforeOwaDate,
            name: loc(TwoDaysBeforeBillDueText),
        });
    }

    return dates;
}
